import { DetailingAPI } from "@/api/DetailingAPI";

export const detailingModule = {
    state: () => ({

    }),
    getters: {
      
    },
    mutations: {
      
    },
    actions: {
      async sendRequest({ commit, rootState }, userInfo){
        return await DetailingAPI.sendRequest(rootState.authorization.userId, userInfo)
          .then((response) => {
            return response.data.message;
          })
          .catch((error) => {
            // let errorStatus = error.response.status
            return error.response.data.message;
          });
      },
      async sendInternetRequest({ commit, rootState }, userInfo){
        return await DetailingAPI.sendInternetRequest(rootState.authorization.userId, userInfo)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            // let errorStatus = error.response.status
            return error.response.status;
          });
      },
    },
    namespaced: true
}